import { TemplateComponentProps } from 'experience-template-renderer-react';
import * as React from 'react';

import { Header } from '@gc/global-components';

export const FullWidthSiteHeader: React.FC<TemplateComponentProps> = () => <Header fullWidth={true} />;
